module.exports = __webpack_public_path__ + "assets/611693ce2bbdc2cc765bd42285e1f683.mp3";